import { useMemo } from 'react';

export const useCSRFToken = () =>
  useMemo(() => $("[name='csrf-token']").attr('content'), []);
